import React from 'react';

const StatusColumn = ({ value, color, light }) => {
	return (
		<span
			className={`label label-lg label-inline p-5 label${
				light ? '-light' : ''
			}-${color}`}
		>
			{value}
		</span>
	);
};

export default StatusColumn;
